enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  FORGOT_PASSWORD = "forgotPassword",
  RESET_PASSWORD = "resetPassword",
  MFA_CODE = "mfaCode",
  RESEND_PASSWORD_RESET_CODE = "resetPasswordResetCode",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  SET_THEME_MODE_ACTION = "setThemeModeAction",
  SET_HEADER_MENU_ACTION = "setHeaderMenuAction",
  CONFIRM_SIGNUP = "confirmSignp",
  RESEND_CONFIRMATION_CODE = "resendConfirmationCode",
  REFRESH_TOKEN = "refreshToken",
  PURGE_AUTH = "purgAuth",
  GET_PROFILE = "getProfile",
  UPDATE_CONTACT_DETAILS = "updateContactDetails",
  UPDATE_BIOGRAPHY = "updateBiography",
  GET_OVERVIEW = "getOverview",
  GET_PAYMENTS = "getPayments",
  GET_PAYMENT = "getPayment",
  ADD_PAYMENT = "addPayment",

  GET_JOBS = "getJobs",
  GET_JOB = "getJob",

  GET_JOB_NOTIFICATIONS = "getJobNotifications",
  MARK_NOTIFICATION_AS_READ = "markNotificationAsRead",
  MARK_JOB_NOTIFICATION_AS_READ = "markJobNotificationAsRead",

  //
  GET_JOB_DOCUMENTS = "getJobDocuments",
  GET_JOB_DOCUMENT = "getJobDocument",
  REQUEST_DOCUMENT = "requestDocument",
  ADD_NEW_DOCUMENT = "addNewDocument",
  UPDATE_DOCUMENT = "updateDocument",
  DELETE_DOCUMENT = "deleteDocument",
  SUBMIT_DOCUMENT = "submitDocument",

  GET_JOB_PAYMENTS = "getJobPayments",
  UPDATE_PAYMENT = "updatePayment",

  GET_JOB_TIMELINE = "getJobTimeline",
  GET_AVAILABLE_JOBS = "getAvailableJobs",
  GET_JOB_FORM = "getJobForm",
  GET_PENDING_OFFERS_JOBS = "getPendingOffersJobs",
  GET_JOBS_WITH_MY_OFFERS = "getJobsWithMyOffers",
  BID_A_JOB = "bidAJob",
  ADD_NEW_DRAFT_OFFER = "addNewDraftOffer",
  UPDATE_DRAFT_OFFER = "updateDraftOffer",
  SUBMIT_OFFER = "submitOffer",
  CANCEL_OFFER = "cancelOffer",
  CANCEL_JOB = "cancelJob",
  GET_ALL_EXPERTISES = "getAllExpertises",
  GET_COUNTRIES = "getCountries",
  GET_USER_TYPE = "getUserType",
  UPLOAD_FILE = "uploadFile",
  GET_S3_SIGNED_URL = "getS3SignedUrl",
  REQUEST_PERMISSION = "requestPermission",
  GET_OR_REFRESH_FCM_TOKEN = "getOrUpdateFcmToken",
  UPDATE_FCM_TOKEN_IN_FIREBASE = "updateFcmTokenInFirebase",
  GET_USERS_IN_FIREBASE = "getUsersInFirebase",
  GET_USER_IN_FIREBASE = "getUserInFirebase",
  VALIDATE_FCM_TOKEN = "validateFcmToken",
  SET_USER_ACTION = "setUserAction",
  GET_PRODUCTS = "getProducts",
  GET_PRODUCT_DETAILS = "getProductDetails",
  ADD_OR_UPDATE_PRODUCT = "addOrUpdateProduct",
  PUBLISH_PRODUCT = "publishProduct",
  PAUSE_PRODUCT = "pauseProduct",
  UPDATE_SETTINGS = "updateSettings",
  GET_JOB_REVIEW = "getJobReview",
  ADD_JOB_REVIEW = "addJobReview",
  UPDATE_JOB_REVIEW = "updateJobReview",
  GET_PRODUCT_QUESTIONS = "getProductQuestions",
  SUBMIT_TO_REVIEW = "submitToReview",
  UPDATE_USER_STATUS = "updateUserStatus",
  GET_CATEGORIES_AS_TREE = "getCategoriesAsTree",
  GET_PRODUCTS_LIST = "getProductsList",
  GET_PRODUCT_OFFERS = "getProductOffers",
  GET_ACCOUNT_DETAILS = "getAccountDetails",
  UPDATE_ACCOUNT_DETAILS = "updateAccountDetails",
  GENERATE_MFA_QR = "generateMfaQr",
  VERIFY_MFA_TOKEN = "verifyMafToken",
  ENABLE_MFA_TOKEN = "enableMfaToken",
  DISABLE_MFA_TOKEN = "disableMfaToken",
  GENERATE_FCM_ACCESS_TOKEN = "generateFcmAccessToken",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_THEME_MODE_MUTATION = "setThemeModeMutation",
  SET_HEADER_MENU_MUTATION = "setHeaderMenuMutation",
  SET_CHALLENGE_PARAMS = "setChallangeParams",
}

enum APIEndpoints {
  PROFILE = "profile",
  BIO = "bio",
  PAYMENTS = "payments",
  JOBS = "jobs",
  JOB = "job",
  DOCS = "docs",
  NOTIFICATIONS = "notifications",
  NOTIFICATION = "notification",
  BID = "bid",
  READ = "read",
  TIMELINE = "timeline",
  EXPERTISE = "expertise",
  COUNTRY = "country",
  USER_TYPE = "user-type",
  AVAILABLE = "available",
  PENDING_OFFERS = "pending-offers",
  JOBS_WITH_MY_OFFERS = "jobs-with-my-offers",
  FORM = "form",
  ADD_DRAFT_OFFER = "add-draft-offer",
  STATUS = "status",
  SUBMIT = "submit",
  CANCEL = "cancel",
  REQUEST = "request",
  PRODUCTS = "products",
  LIST = "list",
  GET_DETAILS = "get-details",
  UPDATE_DETAILS = "update-details",
  PUBLISH_PRODUCT = "publish-product",
  PAUSE_PRODUCT = "pause-product",
  SETTINGS = "settings",
  REVIEW = "review",
  REVIEWS = "reviews",
  GET_PRODUCT_QUESTIONS = "product-questions",
  SUBMIT_TO_REVIEW = "submit-to-review",
  TREE_CATEGORY = "tree-category",
  CATEGORY = "category",
  PRODUCT_OFFERS = "product-offers",
  PAYOUT = "payout",
  PAYOUTS = "payouts",
  ACCOUNT_DETAILS = "account-details",
  MFA = "mfa",
  GENERATE_QR = "generate-qr",
  VERIFY_TOKEN = "verify-token",
  ENABLE_MFA = "enable-mfa",
  DISABLE_MFA = "disable-mfa",
  GENERATE_FIREBASE_TOKEN = "generate-firebase-token",
}

export { Actions, Mutations, APIEndpoints };
